import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { sizing } from "@mui/system";
import { Box } from "../Box/index.js";
import { Skeleton } from "../Skeleton/index.js";
import { MediaEmpty } from "../MediaEmpty/index.js";
import { useImagePreload, useIntersectionObserver } from "../hooks/index.js";
import { useStyles } from "./ImageWithLoader.styles.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ImageWithLoader_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ImageWithLoader_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const ImageWithLoader = (t0)=>{
    const $ = c(48);
    const { src, width, height, objectFit: t1, hasError, emptyVariant: t2, loadImage, onLoad, aspectRatio } = t0;
    const objectFit = void 0 === t1 ? "cover" : t1;
    const emptyVariant = void 0 === t2 ? "single" : t2;
    let t3;
    if ($[0] !== height || $[1] !== width) {
        t3 = sizing({
            width,
            height
        });
        $[0] = height;
        $[1] = width;
        $[2] = t3;
    } else t3 = $[2];
    const sizeStyles = t3;
    let t4;
    if ($[3] !== aspectRatio || $[4] !== objectFit || $[5] !== sizeStyles) {
        t4 = _object_spread_props(_object_spread({}, sizeStyles), {
            objectFit,
            aspectRatio
        });
        $[3] = aspectRatio;
        $[4] = objectFit;
        $[5] = sizeStyles;
        $[6] = t4;
    } else t4 = $[6];
    const { classes } = useStyles(t4);
    const [isIntersected, setIsIntersected] = useState(false);
    const [error, setError] = useState(false);
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            threshold: 0,
            root: null,
            rootMargin: "100px"
        };
        $[7] = t5;
    } else t5 = $[7];
    const [ref, entry] = useIntersectionObserver(t5);
    let t6;
    if ($[8] !== isIntersected || $[9] !== onLoad) {
        t6 = {
            enabled: isIntersected,
            onLoad
        };
        $[8] = isIntersected;
        $[9] = onLoad;
        $[10] = t6;
    } else t6 = $[10];
    const loadedImageStatus = useImagePreload(src, t6);
    let t7;
    if ($[11] !== height || $[12] !== width) {
        t7 = {
            height,
            width,
            maxWidth: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        };
        $[11] = height;
        $[12] = width;
        $[13] = t7;
    } else t7 = $[13];
    const baseBoxParams = t7;
    let t8;
    if ($[14] !== (null == entry ? void 0 : entry.isIntersecting)) {
        t8 = ()=>{
            if (null == entry ? void 0 : entry.isIntersecting) setIsIntersected(true);
        };
        $[14] = null == entry ? void 0 : entry.isIntersecting;
        $[15] = t8;
    } else t8 = $[15];
    const t9 = null == entry ? void 0 : entry.isIntersecting;
    let t10;
    if ($[16] !== t9) {
        t10 = [
            t9
        ];
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    useEffect(t8, t10);
    let t11;
    let t12;
    if ($[18] !== error || $[19] !== isIntersected || $[20] !== loadImage) {
        t11 = ()=>{
            if (!isIntersected || !loadImage || error) return;
            let isActive = true;
            const load = ()=>_async_to_generator(function*() {
                    try {
                        yield loadImage();
                        if (isActive) setError(false);
                    } catch (unused) {
                        if (isActive) setError(true);
                    }
                })();
            load();
            return ()=>{
                isActive = false;
            };
        };
        t12 = [
            loadImage,
            isIntersected,
            error
        ];
        $[18] = error;
        $[19] = isIntersected;
        $[20] = loadImage;
        $[21] = t11;
        $[22] = t12;
    } else {
        t11 = $[21];
        t12 = $[22];
    }
    useEffect(t11, t12);
    if ("complete" === loadedImageStatus) {
        let t13;
        if ($[23] !== classes.img || $[24] !== src) {
            t13 = /*#__PURE__*/ jsx("img", {
                src: src,
                alt: "cover",
                width: "100%",
                height: "100%",
                className: classes.img
            });
            $[23] = classes.img;
            $[24] = src;
            $[25] = t13;
        } else t13 = $[25];
        let t14;
        if ($[26] !== baseBoxParams || $[27] !== classes.wrapper || $[28] !== t13) {
            t14 = /*#__PURE__*/ jsx(Box, _object_spread_props(_object_spread({}, baseBoxParams), {
                position: "relative",
                bgcolor: "bg.dark.primary",
                overflow: "hidden",
                radius: "m",
                testId: "image-with-loader-test-id",
                className: classes.wrapper,
                children: t13
            }));
            $[26] = baseBoxParams;
            $[27] = classes.wrapper;
            $[28] = t13;
            $[29] = t14;
        } else t14 = $[29];
        return t14;
    }
    if ("failed" === loadedImageStatus || hasError || error) {
        let t13;
        if ($[30] !== emptyVariant || $[31] !== height || $[32] !== width) {
            t13 = /*#__PURE__*/ jsx(MediaEmpty, {
                variant: emptyVariant,
                width: width,
                height: height,
                radius: "m",
                testId: "image-with-loader-failed-test-id"
            });
            $[30] = emptyVariant;
            $[31] = height;
            $[32] = width;
            $[33] = t13;
        } else t13 = $[33];
        let t14;
        if ($[34] !== classes.wrapper || $[35] !== t13) {
            t14 = /*#__PURE__*/ jsx(Box, {
                className: classes.wrapper,
                children: t13
            });
            $[34] = classes.wrapper;
            $[35] = t13;
            $[36] = t14;
        } else t14 = $[36];
        return t14;
    }
    let t13;
    if ($[37] !== ref) {
        t13 = /*#__PURE__*/ jsx(Box, {
            ref: ref,
            component: "span",
            position: "absolute"
        });
        $[37] = ref;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== height || $[40] !== width) {
        t14 = /*#__PURE__*/ jsx(Skeleton, {
            height: height,
            width: width,
            variant: "rect"
        });
        $[39] = height;
        $[40] = width;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== classes.wrapper || $[43] !== t14) {
        t15 = /*#__PURE__*/ jsx(Box, {
            testId: "image-with-loader-skeleton-test-id",
            className: classes.wrapper,
            children: t14
        });
        $[42] = classes.wrapper;
        $[43] = t14;
        $[44] = t15;
    } else t15 = $[44];
    let t16;
    if ($[45] !== t13 || $[46] !== t15) {
        t16 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t13,
                t15
            ]
        });
        $[45] = t13;
        $[46] = t15;
        $[47] = t16;
    } else t16 = $[47];
    return t16;
};
export { ImageWithLoader };
